const indexedPaths = {
  "fastqrgenerator.com": ["/", "/contact-us"],
  "qrcreator.com": ["/", "/contact-us", "/qrcreator-dev-scan-tool"],
  "app.qrcreator.com": [],
  "onlineqrcode.com": [],
  "app.onlineqrcode.com": [],
  "qrnow.com": [],
  "app.qrnow.com": [],
};

module.exports = {
  indexedPaths,
};
